import columns from '../../../../../react-table/helpers/columns';
import ReportDefinitions from '../../../../../common/config/ReportDefinitions';
import { sumTotal, totalRowRatio } from '../../../../../react-table/helpers/rowTotals';

export const getCarrierTabNavigationProps = carrierData => rowInfo => (
  rowInfo && rowInfo.row ? {
    reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
    mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id,
    requestParams: {
      operator: rowInfo.row['postalOperator'], // eslint-disable-line
      carriers: carrierData.carriers,
    },
    selectionCriteriaOptions: {
      includeSelectionCriteria: true,
    },
    reportsToBeCleared: [
      ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_DETAILS.id,
    ],
  } : {}
);


export default (data, carrierData) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
    PercentageColumn,
    NavigationWithFooterColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('Postal operator', 'postalOperator').withTotalHeader('Total', 'bg-total-grey'),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NavigationWithFooterColumn(new NonZeroNumberColumn('Total', 'receptacles.total').withTotalHeader(sumTotal, 'bg-total-grey'), getCarrierTabNavigationProps(carrierData)),
        new NonZeroNumberColumn('LHOT origin', 'receptacles.lhotOrigin').withShow(false),
        new NonZeroNumberColumn('LHOT destination', 'receptacles.lhotDestination').withShow(false),
        new NonZeroNumberColumn('Contract reference', 'receptacles.contractReference').withShow(false),
        new NonZeroNumberColumn('Booking reference (PAWB)', 'receptacles.bookingReference').withShow(false),
        new PercentageColumn('% LHOT origin', 'receptacles.pctLhotOrigin').withTotalHeader(totalRowRatio(['receptacles.lhotOrigin', 'receptacles.total']), 'bg-total-grey'),
        new PercentageColumn('% LHOT destination', 'receptacles.pctLhotDestination').withTotalHeader(totalRowRatio(['receptacles.lhotDestination', 'receptacles.total']), 'bg-total-grey'),
        new PercentageColumn('% Contract reference', 'receptacles.pctContractReference').withTotalHeader(totalRowRatio(['receptacles.contractReference', 'receptacles.total']), 'bg-total-grey'),
        new PercentageColumn('% Booking reference (PAWB)', 'receptacles.pctBookingReference').withTotalHeader(totalRowRatio(['receptacles.bookingReference', 'receptacles.total']), 'bg-total-grey'),
      ],
      drillDownLink: {
        reportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_LOCATION.id,
        mainReportId: ReportDefinitions.CARDIT_CRITICAL_ELEMENTS_800_OPERATOR.id,
        requestParams: {
          isTotal: true,
          operator: '*',
        },
        selectionCriteriaOptions: {
          includeSelectionCriteria: true,
        },
      },
    },
  ];
};
